<dialog-header [centered]="true">Request Changes</dialog-header>
<mat-dialog-content class="form-group tw-px-[24px]">
  <p class="tw-mb-[16px]">
    <strong>{{ editorName() }}</strong> has sent this presentation for review.
    Please provide clear, specific details so they can revise and resubmit the
    presentation.
  </p>
  <label class="tw-font-medium" for="details">Details</label>
  <textarea
    id="details"
    matInput
    rows="3"
    [(ngModel)]="details"
    placeholder="Describe the changes needed before resubmitting."
    class="form-control comments"
  ></textarea>
</mat-dialog-content>
<rv-divider class="tw-my-[24px]" />
<mat-dialog-actions align="end">
  <button matButton="outlined" [mat-dialog-close]="null">Cancel</button>
  <button
    mat-flat-button
    color="primary"
    [disabled]="!details"
    [mat-dialog-close]="result"
  >
    Request Changes
  </button>
</mat-dialog-actions>
